export const DAYS_OF_WEEK = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
];

const makeDay = (enabled) => ({
  enabled,
  start: '08:00',
  end: '18:00',
});

export const createDefaultSchedule = () => ({
  alwaysOn: false,
  days: {
    monday: makeDay(true),
    tuesday: makeDay(true),
    wednesday: makeDay(true),
    thursday: makeDay(true),
    friday: makeDay(true),
    saturday: makeDay(false),
    sunday: makeDay(false),
  },
});

export const normalizeSchedule = (schedule) => {
  const defaults = createDefaultSchedule();
  if (!schedule || typeof schedule !== 'object') {
    return defaults;
  }

  const normalized = {
    alwaysOn: Boolean(schedule.alwaysOn),
    days: {},
  };

  const sourceDays = schedule.days && typeof schedule.days === 'object' ? schedule.days : {};

  DAYS_OF_WEEK.forEach(({ key }) => {
    const fallback = defaults.days[key];
    const incoming = sourceDays[key] && typeof sourceDays[key] === 'object' ? sourceDays[key] : {};

    normalized.days[key] = {
      enabled: incoming.enabled ?? fallback.enabled,
      start: typeof incoming.start === 'string' && incoming.start ? incoming.start : fallback.start,
      end: typeof incoming.end === 'string' && incoming.end ? incoming.end : fallback.end,
    };
  });

  return normalized;
};
